"use client"

import { AlertTriangle, X } from "lucide-react"
import { useAuth } from "../../context/AuthContext"
import { dictionary } from "../../utils/dictionary"
interface CancelPlanModalProps {
  isOpen: boolean
  onClose: () => void
  onSupport: () => void
  onCancel: () => void
}

export function CancelPlanModal({ isOpen, onClose, onSupport, onCancel }: CancelPlanModalProps) {
  if (!isOpen) return null
  const { language } = useAuth();

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />

      <div className="relative bg-white rounded-3xl shadow-lg w-full max-w-md mx-4 p-6">
        <button onClick={onClose} className="absolute top-4 right-4 text-gray-400 hover:text-gray-600">
          <X className="w-5 h-5" />
        </button>

        <div className="space-y-6">
          <div className="flex justify-center">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center">
              <AlertTriangle className="w-8 h-8 text-blue-600" />
            </div>
          </div>

          <div className="text-center space-y-2">
            <h2 className="text-xl font-semibold text-gray-900">{dictionary["are-you-sure-you-want-to-leave"][language]}</h2>
            <p className="text-gray-600">
              {dictionary["before-you-lose-access-to-your-funnels-and-metrics-is-there-anything-we-can-resolve-together"][language]}
            </p>
          </div>

          <div className="space-y-3">
            <button
              onClick={onSupport}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 rounded-lg transition-colors"
            >
              {dictionary["i-prefer-to-talk-to-support"][language]}
            </button>

            <button
              onClick={onCancel}
              className="w-full border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 font-medium py-3 rounded-lg transition-colors"
            >
              {dictionary["yes-i-want-to-cancel-my-subscription"][language]}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
